import { CenteredMessagePage } from "@components/CenteredMessagePage"
import { useRouteShellContext } from "@components/routeShellContext"
import * as m from "@paraglide/messages"

export function ErrorPage() {
  const { locale } = useRouteShellContext()
  return (
    <CenteredMessagePage
      className="page-error"
      title={m.error_404_label({}, { locale: locale })}
      linkHref="/"
      linkLabel={m.back_toHome({}, { locale: locale })}
    >
      <p>{m.error_404_description({}, { locale: locale })}</p>
    </CenteredMessagePage>
  )
}
